// extracted by mini-css-extract-plugin
module.exports = {"imageArticle":"styles_imageArticle__E3qzR","description":"styles_description__pXurY"};